import {
  AboutYouState,
  AccountDetailsState,
  AddressState,
  ApplicantState,
  BalanceTransferState,
  CreditCardCancellationState,
  FinancialDetailsState,
  ForeignTaxDetailsState,
  MemberDetailsState,
  TaxDetailsState,
  VerifyIdentityState,
} from './types';

export const memberDetailsInitialState: MemberDetailsState = {
  isExistingMember: null,
  isPrimary: false,
  customerId: '',
  password: '',
  relationshipType: 'O',
  isAdditionalApplicantWithYou: null,
  isAdditionalCardholder: false,
  areMemberDetailsPrePopulated: false,
};

export const addressInitialState: AddressState = {
  dpid: '',
  address: '',
  lot: '',
  buildingName: '',
  buildingLevelType: '',
  buildingLevelNumber: '',
  unitType: '',
  unitNumber: '',
  streetName: '',
  streetNumber: '',
  streetType: '',
  streetSuffix: '',
  suburb: '',
  state: '',
  postcode: '',
  postalDeliveryType: '',
  postalDeliveryNumber: '',
  previousAddressYearLength: null,
  previousAddressMonthLength: null,
};

export const aboutYouInitialState: AboutYouState = {
  title: '',
  gender: '',
  firstName: '',
  middleName: '',
  lastName: '',
  emailAddress: '',
  sameEmailAddress: null,
  noticeOfMeetings: false,
  annualReports: false,
  mobileNumber: '',
  sameMobileNumber: null,
  newMobileNumber: '',
  securityCode: '',
  smsVerified: false,
  verificationKeyword: '',
  birthday: '',
  age: 0,
  citizenship: '',
  occupation: '',
  receivePension: null,
  customerId: '',
  password: '',

  residentialAddress: addressInitialState,
  previousAddress: addressInitialState,
  postalAddress: addressInitialState,
  mailingDestination: '',
  postalAddressType: '',
  currentAddressYearLength: null,
  currentAddressMonthLength: null,
  previousAddressYearLength: null,
  previousAddressMonthLength: null,
  addressSameAsPrimary: null,

  //Employment details
  employmentStatus: '',
  employersName: '',
  employersPhoneNumber: '',
  currentEmploymentLengthYear: null,
  currentEmploymentLengthMonth: null,
  previousOccupation: '',
  previousEmployersName: '',
  previousEmploymentLengthYear: null,
  previousEmploymentLengthMonth: null,

  //Consent
  electronicCommunicationConsent: null,
  electronicPromotionalCommunicationConsent: null,
  dVSConsentAuthorised: null,
};

export const verifyIdentityInitialState: VerifyIdentityState = {
  familyName: '',
  givenName: '',
  otherGivenNames: '',
  primaryIdentity: '',
  secondaryIdentity: '',
  addSecondaryIdentity: null,
  // Drivers licence
  driverIssueState: '',
  driverLicenceNumber: '',
  driverLicenceCardNumber: '',
  // Medicare card
  medicareFamilyName: '',
  medicareOtherGivenNames: '',
  medicareGivenName: '',
  medicareCardColor: '',
  medicareCardNumber: '',
  medicareReferenceNumber: '',
  medicareMiddleName: '',
  medicareExpiryDate: '',
  // Passport
  passportNumber: '',
  passportCountryCode: '',
  // Birth certificate
  birthFamilyName: '',
  birthOtherGivenNames: '',
  birthGivenName: '',
  birthState: '',
  birthDateOfPrint: '',
  birthRegistrationNumber: '',
  birthRegistrationDate: '',
  birthRegistrationDistrict: '',
};

export const accountDetailsInitialState: AccountDetailsState = {
  offsetAccountRequired: null,
  offsetAccount: '',
  additionalAccountToOpen: 'SSA',
  additionalAccountAdded: null,
  haveCampaignCode: null,
  campaignCode: '',
  cardColorMain: 4,
  cardColorAdditional: 4,
  cardType: 1,
  cardTypeAdditionalAccount: 1,
  addCardMain: null,
  addCardAdditional: null,

  depositAmount: null,
  interestPaymentOption: '',
  investmentTermType: '',
  investmentTerm: null,
  depositMethod: '',
  interestPaidTo: '',
  interestRate: '0',
  paidToNpbsAccountName: '',
  paidToNpbsAccountNumber: '',
  paidToOtherAccountName: '',
  paidToOtherBsb: '',
  paidToOtherAccountNumber: '',
  methodOfOperation: '1',
};

export const creditCardCancellationInitialState: CreditCardCancellationState = {
  cardType: '',
  cardLimit: null,
};

export const balanceTransferInitialState: BalanceTransferState = {
  accountName: '',
  accountIssuer: '',
  accountNumber: '',
  bpayBillerCode: '',
  amount: null,
};

export const financialDetailsInitialState: FinancialDetailsState = {
  preferredCreditLimit: null,
  monthlySalary: null,
  otherMonthlyIncome: null,

  npbsAccountsCount: '',
  npbsAccountsTotalBalance: null,
  otherAccountsCount: '',
  otherAccountsTotalBalance: null,

  residentialStatus: '',
  homeOwner: false,
  haveMortgage: false,
  renting: false,
  livingWithParents: false,
  residenceValue: null,
  homeLoansTotalBalance: null,

  monthlyMortgageRepayments: null,
  monthlyRent: null,
  monthlyLoanRepayments: null,

  otherAssetsValue: null,

  haveOtherCreditCards: null,
  creditCardsCount: null,
  creditCardsTotalLimit: null,

  haveOtherLoans: null,
  otherLoansTotalBalance: null,

  haveDependants: null,
  numberOfDependants: null,

  balanceTransferRequired: null,
  balanceTransferDetails: [],
  cancelAndReplaceCardsRequired: null,
  creditCardCancellationDetails: [],

  addAdditionalCardholderRequired: null,
  numberOfAdditionalCardHolders: null,
  additionalCardholderWithYou: null,

  haveCampaignCode: null,
  campaignCode: '',
};

export const foreignTaxDetailsInitialState: ForeignTaxDetailsState = {
  taxCountry: '',
  tinType: '',
  otherTINType: '',
  tinNumber: '',
  noTinReason: '',
};

export const taxDetailsInitialState: TaxDetailsState = {
  provideTFN: '',
  tfn: '',
  exemptTFN: '',
  taxResidentAusOnly: null,
  foreignTaxDetails: [],
  sourceOfFunds: '',
  purposeOfAccount: '',
};

export const applicantInitialState: ApplicantState = {
  applicantId: '',
  memberDetails: memberDetailsInitialState,
  aboutYou: aboutYouInitialState,
  verifyIdentity: verifyIdentityInitialState,
  accountDetails: accountDetailsInitialState,
  taxDetails: taxDetailsInitialState,
  financialDetails: financialDetailsInitialState,
};
